import { coachRoles, isCoach } from 'helpers/profile';

export const getPermissions = (profile, user, coaching, downline) => {
    if (!profile || !user) {
        return {
            objectives: {},
            one2ones: {},
            pathways: {},
            reviews: {},
        };
    }

    const isMe = user.id === profile.id;
    const noManager = !user.manager_Id;
    const isOwnManager = isMe && noManager;
    const isUplineManager = downline?.some(d => d.id === profile.id && d.id !== user.id);
    const isDirectManager = user.id === profile.manager_Id;
    const isManager = isDirectManager || isOwnManager || isUplineManager;
    const isAdmin = user.administrator;
    const isActive = profile.active;

    const coach = role => isCoach(profile.id, user.companySettings, coaching, role);

    const view121 = coach(coachRoles.view121);
    const manage121 = coach(coachRoles.manage121);
    const viewObjectives = coach(coachRoles.viewObjectives);
    const manageObjectives = coach(coachRoles.manageObjectives);
    const viewPathways = coach(coachRoles.viewPathways);
    const managerPathways = coach(coachRoles.managePathways);
    const viewReviews = coach(coachRoles.viewReviews);
    const manageReviews = coach(coachRoles.manageReviews);
    /*
    console.log('profile / user', profile.id, user.id);
    console.log('isMe', isMe);
    console.log('isManager', isManager);
    console.log('isManager (D, O, U)', isDirectManager, isOwnManager, isUplineManager, downline);
    console.log('isAdmin', isAdmin);
    console.log('view121', view121);
    console.log('manage121', manage121);
    console.log('viewObjectives', viewObjectives);
    console.log('manageObjectives', manageObjectives);
    console.log('viewPathways', viewPathways);
    console.log('managerPathways', managerPathways);
    console.log('viewReviews', viewReviews);
    console.log('managerReviews', manageReviews);
    console.log('----------------------');
*/
    return {
        objectives: {
            canView: isMe || isAdmin || isManager || viewObjectives,
            canAdd: isMe || isAdmin || isManager || manageObjectives,
            canEdit: ownerId => isAdmin || user.id === ownerId,
            canDeleteComment: ownerId => isAdmin || user.id === ownerId,
            canPoke: isAdmin || isManager || manageObjectives,
            canShare: ownerId => isMe || isAdmin || isManager || user.id === ownerId,
            canApproveAndReject: isAdmin || isManager || manageObjectives,
        },
        one2ones: {
            canAddObjectives: isActive && (isMe || isAdmin || isManager || manageObjectives),
            canAddNote: isActive && (isMe || isAdmin || isManager || view121),
            canEditNote: ownerId => isAdmin || (isActive && user.id === ownerId),
            canDeleteNote: ownerId => isAdmin || (isActive && user.id === ownerId),
            canView: isMe || isAdmin || isManager || view121,
            canViewObjectives: isMe || isAdmin || isManager || viewObjectives,
            canFlag: isActive && (isAdmin || isManager || manage121),
            canRate: isActive && (isAdmin || isManager || manage121),
            canEditPersonalGoals: isActive && (isMe || isAdmin || isManager || manage121),
            canEditMetricGoals: isActive && (isMe || isAdmin || isManager || manage121),
        },
        pathways: {
            canView: isMe || isAdmin || isManager || viewPathways,
            canViewObjectives: isMe || isAdmin || isManager || viewObjectives,
            canEnrol: isActive && (isAdmin || isManager || managerPathways),
        },
        reviews: {
            canView: isAdmin || isMe || isManager || viewReviews,
            canSchedule: isActive && (isAdmin || isManager || manageReviews),
            canEditSchedule: isAdmin || isManager || manageReviews,
            canComplete: app => isMe || (!app.coach_Id && isDirectManager) || (app.coach_Id === user.id && manageReviews),
            resetStatus: isAdmin,
            canDelete: isAdmin || isManager || manageReviews,
        },
    };
};
